export function initializeUsers() {
    return {
        type: 'USERS_INITIALIZE',
    }
}

export function clearUsers() {
    return {
        type: 'USERS_CLEAR',
    }
}

export function clearUsersError() {
    return {
        type: 'CLEAR_USERS_ERRORS',
    }
}

export function closeLoginFetch() {
    return {
        type: 'API_LOGIN_CLOSE_FETCH',
    }
}

export function closeGetUsersFetch() {
    return {
        type: 'API_GET_USERS_CLOSE_FETCH',
    }
}

export function closePostUserFetch() {
    return {
        type: 'API_POST_USER_CLOSE_FETCH',
    }
}

export function closePutUserFetch() {
    return {
        type: 'API_PUT_USER_CLOSE_FETCH',
    }
}

export function closeDeleteUserFetch() {
    return {
        type: 'API_DELETE_USER_CLOSE_FETCH',
    }
}

export function loginUser(user) {
    return {
        type: 'API_AUTH_SIGN_IN',
        payload: {
            request: {
                method: 'POST',
                url: '/auth/sign_in',
                data: user
            }
        }
    }
}

export function authValidateToken() {
    return {
        type: 'API_AUTH_VALIDATE_TOKEN',
        payload: {
            request: {
                method: 'GET',
                url: '/auth/validate_token'
            }
        }
    }
}

export function getUsers(companyId) {
    return {
        type: 'API_GET_USERS',
        payload: {
            request: {
                method: 'GET',
                url: `/companies/${companyId}/user`
            }
        }
    }
}

export function createUser(user, companyId) {
    return {
        type: 'API_AUTH_CREATE_USER',
        payload: {
            request: {
                method: 'POST',
                url: '/auth',
                data: {
                    ...user,
                    company_id: companyId
                },
            }
        }
    }
}

export function updateUser(user) {
    return {
        type: 'API_AUTH_UPDATE_USER',
        payload: {
            request: {
                method: 'PUT',
                url: `/user/${user.id}`,
                data: user,
            }
        }
    }
}

export function deleteUser(user) {
    return {
        type: 'API_DELETE_USER',
        payload: {
            request: {
                method: 'DELETE',
                url: `/user/${user.id}`,
            }
        }
    }
}

export function setEditUser(user) {
    return {
        type: 'SET_EDIT_USER',
        payload: {
            user: user
        },
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/users.js